import { Fragment, useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Divider,
  Spin,
  DatePicker,
  InputNumber,
  Row,
  Col,
  Select,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Transport_ModeOptions } from "../../Services/VoucherServices";

const AddSalesInvoiceExportDetail: React.FC<{
  open: boolean;
  onCancel: any;
  data: any;
  saveData: any;
}> = (props) => {
  console.log("props", props);
  const [form] = Form.useForm();
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  // const [groupData, setGroupData] = React.useState<any[]>();
  const [loading, setLoading] = useState<boolean>(false);

  const saveGroup = () => {
    setSaveButtonLoading(true);

    form.validateFields().then(async (value) => {
      setSaveButtonLoading(false);
      props.data(value);
      props.onCancel();
      console.log(value);
    });
  };

  useEffect(() => {
    if (props.saveData) {
      const data = {
        ...props.saveData,
      };
      form.setFieldsValue(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.saveData]);

  return (
    <Fragment>
      <Modal
        open={props.open}
        title="Add Export Details"
        maskClosable={false}
        width={750}
        style={{ top: 44 }}
        onCancel={() => props.onCancel({})}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button
              onClick={() => {
                form.resetFields();
                props.onCancel({});
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => saveGroup()}
              style={{ width: "80px" }}
              loading={saveButtonLoading}
              className="modelSaveButtonMargin"
            >
              Save
            </Button>
          </div>
        }
      >
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          spinning={loading}
        >
          <Form
            name="exportDetail"
            form={form}
            autoComplete="off"
            colon={false}
            labelAlign="left"
            // initialValues={intialValue}
            labelCol={{ xs: 7, sm: 10 }}
            wrapperCol={{ xs: 16, sm: 14 }}
            labelWrap={true}
          >
            <Divider className="ca-model-css" />
            {/* <Form.Item
              name="goodsReceiptPlace"
              label="Receipt Place"
              className="mb-14"
              //   rules={[{ required: true, message: "Account Code is required" }]}
            >
              <Input autoFocus={true} ref={inputRef} />
            </Form.Item> */}
            <Row
              style={{ justifyContent: "space-between" }}
              gutter={{ sm: 14 }}
            >
              <Col sm={12} xs={24}>
                <Form.Item name="vesselNo" label="Vessel No" className="mb-12">
                  <Input placeholder="Vessel No" />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24}>
                <Form.Item name="blNumber" label="BL Number" className="mb-14">
                  <Input placeholder="BL Number" />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name="shipDocNo"
                  label="Ship Document No"
                  className="mb-12"
                >
                  <Input placeholder="Ship Document No" />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24}>
                <Form.Item
                  name="shipDate"
                  className="mb-12"
                  label="Shipping Date"
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    // disabledDate={(current) =>
                    //   current && current > dayjs().endOf("day")
                    // }
                    style={{ width: "100%" }}
                    // onChange={(val) => {
                    //   if (dueOn) {
                    //     let dueDate = dayjs(val, "DD/MM/YYYY").add(dueOn, "day");
                    //     form.setFieldValue("dueDate", dueDate);
                    //   }
                    //   setDateFiled(dayjs(val).toISOString());
                    // }}
                  />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name="loadingPort"
                  label="Loading Port"
                  className="mb-14"
                  //   rules={[{ required: true, message: "Account Type is required" }]}
                >
                  <Input placeholder="Loading Port" />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24}>
                <Form.Item
                  name="dischargePort"
                  label="Discharge Port"
                  className="mb-14"
                  //   rules={[{ required: true, message: "Nature is required" }]}
                >
                  <Input placeholder="Discharge Port" />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name="transportMode"
                  label="Transport Mode"
                  className="mb-14"
                >
                  <Select
                    placeholder="Transport Mode"
                    options={Transport_ModeOptions}
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name={["insuranceDetail", "insuranceValue"]}
                  label="Insurance Value"
                  className="mb-14"
                >
                  <InputNumber
                    placeholder="Insurance Value"
                    style={{ width: "100%" }}
                    controls={false}
                  />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name={["insuranceDetail", "policyNo"]}
                  label="Policy No"
                  className="mb-14"
                >
                  <Input placeholder="Policy No" />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24}>
                <Form.Item
                  name={["insuranceDetail", "policyDate"]}
                  label="Policy Date"
                  className="mb-14"
                >
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>

              {/* <Form.Item
              name="countryTo"
              label="Country To"
              className="mb-14"
              valuePropName="checked"
              //   rules={[{ required: true, message: "Statement  is required" }]}
            >
              <Checkbox />
            </Form.Item> */}
            </Row>
          </Form>
          <Divider className="divider-account" />
        </Spin>
      </Modal>
    </Fragment>
  );
};

export default AddSalesInvoiceExportDetail;
